<template>
  <div class="homepage-header">
    <div class="part part-one">
      <div class="homepage-pic">
        <img :src="list[active]" alt="明星宣传照" />
      </div>
      <div class="btn" @click="checkRule">
        <img
          src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/btn_rule.png"
          alt="活动规则"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePageHeader",
  props: {
    active: {
      type: Number,
      default() {
        return 0
      }
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    checkRule() {
      this.$openDialog('RuleDialog');
    }
  }
};
</script>

<style lang="scss" scoped>
.homepage-header {
  .part {
    width: 100%;

    &.part-one {
      position: relative;
      .homepage-pic {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .btn {
        position: absolute;
        right: 0;
        top: 160px;
        padding: 30px;
        img {
          width: 66px;
          height: 66px;
        }
      }
    }
  }
}
</style>
